var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMedicineArchive(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1080,
    height: 1080,
    viewBox: "-93.85 -15.26 1080 1080",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Fabric.js 5.2.4")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 540 540)",
    id: "744448f8-b61c-4319-8b18-276eb0abeeda"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 540 540)",
    id: "77e079bb-ba16-4e71-ae4e-200198072354"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "#B4B6B5",
      fillRule: "nonzero",
      opacity: 1,
      visibility: "hidden"
    },
    vectorEffect: "non-scaling-stroke",
    x: -540,
    y: -540,
    rx: 0,
    ry: 0,
    width: 1080,
    height: 1080
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 540 499.61)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {},
    vectorEffect: "non-scaling-stroke"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 266.75 84.38)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "#B4B6B5",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-771.5, -504.2)",
    d: "M 771.5 498.7 L 771.5 509.7 L 771.5 509.7 L 771.5 498.7 L 771.5 498.7 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 318.75 92.23)"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "#B4B6B5",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    x: -30,
    y: -24.35,
    rx: 0,
    ry: 0,
    width: 60,
    height: 48.7
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 307.75 206.73)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "#B4B6B5",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-812.5, -626.55)",
    d: "M 987.5 559.4 L 987.5 693.5 C 987.5 694 987 694.5 986.5 694.5 L 771.5 694.5 L 771.5 765.5 C 771.5 765.9 771.2 766.3 770.9 766.4 C 770.5 766.6 770.1 766.5 769.8 766.1999999999999 L 637.8 627.1999999999999 C 637.4 626.8 637.4 626.1999999999999 637.8 625.8 L 748 509.79999999999995 L 758.4 498.79999999999995 L 768.9 487.79999999999995 L 769.8 486.79999999999995 L 769.8 486.79999999999995 C 769.8 486.79999999999995 769.9 486.69999999999993 769.9 486.69999999999993 C 770 486.5999999999999 770.1 486.5999999999999 770.1 486.5999999999999 C 770.1 486.5999999999999 770.2 486.5999999999999 770.3000000000001 486.5999999999999 C 770.3000000000001 486.5999999999999 770.4000000000001 486.5999999999999 770.4000000000001 486.5999999999999 C 770.5000000000001 486.5999999999999 770.5000000000001 486.5999999999999 770.6000000000001 486.5999999999999 C 770.7000000000002 486.5999999999999 770.8000000000002 486.5999999999999 770.9000000000001 486.69999999999993 C 771.1000000000001 486.79999999999995 771.3000000000001 486.99999999999994 771.4000000000001 487.19999999999993 C 771.4000000000001 487.29999999999995 771.5000000000001 487.3999999999999 771.5000000000001 487.49999999999994 C 771.5000000000001 487.49999999999994 771.5000000000001 487.59999999999997 771.5000000000001 487.59999999999997 L 771.5000000000001 498.9 L 771.5000000000001 498.9 L 771.5000000000001 558.6 L 986.5000000000001 558.6 C 987 558.4 987.5 558.9 987.5 559.4 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "#B4B6B5",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-504.75, -419.82)",
    d: "M 1003.2 403.8 L 951 348.9 L 951 247 C 951 228.6 936 213.6 917.6 213.6 L 516.3 213.6 C 507.59999999999997 213.6 500.19999999999993 206.5 500.09999999999997 197.79999999999998 C 499.9 185.1 508.79999999999995 181.89999999999998 517.5 181.89999999999998 L 663.3 181.89999999999998 L 491 9.6 C 484.9 3.4 476.6 0 467.9 0 L 39.3 0 C 17.6 0 0 17.6 0 39.3 L 0 806.6999999999999 C 0 824.8 14.7 839.4999999999999 32.8 839.4 C 174.7 838.6 317.5 840.1999999999999 459.3 839.4 L 920.4000000000001 839.4 C 926.7 839.4 931.6000000000001 836.8 937.3000000000001 833.1 C 941.5000000000001 830.4 944.3000000000001 825.7 946.8000000000001 821.4 C 949.5000000000001 816.8 951.0000000000001 811.4 951.0000000000001 805.6999999999999 L 951.0000000000001 716.5999999999999 L 793.5 716.5999999999999 L 793.5 765.5999999999999 C 793.5 775.0999999999999 787.8 783.3999999999999 779 786.9999999999999 C 776.2 788.0999999999999 773.3 788.6999999999999 770.4 788.6999999999999 C 764.1999999999999 788.6999999999999 758.1999999999999 786.1999999999999 753.8 781.4999999999999 L 621.8 642.4999999999999 C 613.4 633.5999999999999 613.4 619.6999999999999 621.8 610.7999999999998 L 717.5999999999999 509.89999999999986 L 728.0999999999999 498.89999999999986 L 738.4999999999999 487.89999999999986 L 638.4999999999999 487.89999999999986 C 637.9999999999999 487.89999999999986 637.4999999999999 487.39999999999986 637.4999999999999 486.89999999999986 L 637.4999999999999 352.6 C 637.4999999999999 352.1 637.9999999999999 351.6 638.4999999999999 351.6 L 853.4999999999999 351.6 L 853.4999999999999 280.6 C 853.4999999999999 280.20000000000005 853.7999999999998 279.8 854.0999999999999 279.70000000000005 C 854.4999999999999 279.50000000000006 854.8999999999999 279.6 855.1999999999999 279.90000000000003 L 951 380.9 L 987.2 419 C 987.6 419.4 987.6 420 987.2 420.4 L 951 458.5 L 877 536.4 L 951 536.4 L 951 490.4 L 1003.2 435.5 C 1011.6 426.6 1011.6 412.7 1003.2 403.8 L 1003.2 403.8 z M 173 109.9 C 173 104.5 177.4 100.60000000000001 182.3 100.60000000000001 L 344.1 100.60000000000001 C 349.5 100.60000000000001 353.40000000000003 105.00000000000001 353.40000000000003 109.9 L 353.40000000000003 177.7 C 353.40000000000003 182.6 349.00000000000006 187 343.6 187 L 182.2 187 C 176.79999999999998 187 172.89999999999998 182.6 172.89999999999998 177.7 C 173 177.6 173 109.9 173 109.9 z M 260.7 643.7 L 88.2 643.7 C 82.8 643.7 78.4 639.3000000000001 78.4 633.9000000000001 L 78.4 374.1 C 77.9 357 79.9 259 178.3 237.6 L 178.3 212.7 L 346.5 212.7 L 346.5 238.1 C 346.5 238.1 371.8 242 397.2 261.1 C 422.5 280.20000000000005 447.9 314.6 447.9 375.5 L 448.4 455.9 C 444.7 457.9 441.29999999999995 460 438 462.5 C 434.7 465 431.5 467.8 428.4 471 L 273.4 626 C 268 631.5 263.7 637.3 260.7 643.7 z M 566.4 600.9 C 564.1999999999999 604.1999999999999 561.6999999999999 607.4 559 610.5 C 558.1 611.5 557.2 612.5 556.2 613.4 L 550.6 619 L 416.2 753.3 L 415.2 754.3 C 383.5 784.5 333.79999999999995 784.5 302.6 753.3 C 286.90000000000003 737.5999999999999 279.1 717.0999999999999 279.1 696.6999999999999 C 279.1 676.3 286.70000000000005 656.4 301.70000000000005 640.6999999999999 L 443.1 499.29999999999995 C 466.6 475.79999999999995 501 469.99999999999994 530 482.09999999999997 C 533.8 483.7 537.5 485.59999999999997 541.1 487.79999999999995 C 544.5 489.9 547.8000000000001 492.29999999999995 550.9 494.9 C 552.6999999999999 496.4 554.5 498.09999999999997 556.1999999999999 499.79999999999995 C 571.8 515.4 579.5999999999999 536 579.5999999999999 556.5999999999999 C 579.6 572.1 575.2 587.6 566.4 600.9 L 566.4 600.9 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -241.8 3.98)"
  }, /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "#B4B6B5",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    points: "93.35,-34.6 93.35,32.2 33.35,32.2 33.35,93.6 -33.35,93.6 -33.35,32.2 -93.35,32.2 -93.35,-34.6 -33.35,-34.6 -33.35,-93.6 33.35,-93.6 33.35,-34.6 "
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -117.73 249.68)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "#B4B6B5",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-387.01, -669.5)",
    d: "M 476.7 671 L 407.5 740.2 C 394.8 752.9000000000001 378.3 759.2 361.7 759.2 C 345.09999999999997 759.2 328.7 752.9000000000001 316.3 740.2 C 291 714.9000000000001 291 673.9000000000001 316.3 649 L 385.5 579.8 L 476.7 671 L 476.7 671 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 266.75 84.38)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "#B4B6B5",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-771.5, -504.2)",
    d: "M 771.5 498.7 L 771.5 509.7 L 771.5 509.7 L 771.5 498.7 L 771.5 498.7 z",
    strokeLinecap: "round"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(5.25 0 0 7.85 812.7 610.8)",
    id: "56f024dd-7e2b-4dae-ae5c-e5ae5a5171cc"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "rgb(0,0,0)",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "#B4B6B5",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    x: -33.085,
    y: -33.085,
    rx: 0,
    ry: 0,
    width: 66.17,
    height: 66.17
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0 0 0 0 0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {}
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedicineArchive);
export default __webpack_public_path__ + "static/media/medicine-archive.fea775e9a9e3b78c609d539576886b27.svg";
export { ForwardRef as ReactComponent };